import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import Grid from "@mui/material/Grid";
import TransectionImg from "assets/img/img6.svg";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import RadioButton from "components/Ui/RadioButton";
import { useFormik } from "formik";
import { useStore } from "_Store";
import IntrantChoose from "../IntrantChoose";
import PhytoChoose from "../PhytoChoose";
import SemenceChoose from "../SemenceChoose";
import FarmPanel from "../FarmParcel";
const ProductType = (props) => {
  const { state } = useStore();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const options = [
    {
      label: "Culture",
      value: "culture",
    },
    {
      label: "Semence",
      value: "semence",
    },
    {
      label: "Intrant",
      value: "intrant",
    },
    {
      label: "Produit Phyto",
      value: "phyto",
    }
  ];
  const formik = useFormik({
    initialValues: {
      productType: state?.["tableDataResponse"]?.["productType"] || "",
    },
    onSubmit: (vals) => {
      Object.keys(vals).forEach((key) => {
        if (vals[key] === null) {
          delete obj[key];
        }
      });
      props.onSubmit(vals, saveAndContinue);
    },
  });
  const { values } = formik
  const addNewSteps = (key) => {
    let tab={
      'culture': {
        label: "Choix de la culture",
        value:'culture',
        element: FarmPanel,
      },
      'intrant': {
        label: "Choix de l'engrais",
        value:'intrant',
        element: IntrantChoose,
      },
      'phyto': {
        label: "Choix du produit phyto",
        value:'phyto',
        element: PhytoChoose,
      },
      'semence':{
        label: "Choix de la semence",
        value:'semence',
        element: SemenceChoose,
      }
    };
    return tab[key];
  }
  const handleChange = (item) => {
    const name = item.toLowerCase();
    const data=addNewSteps(name);
    props.addToSteps(data);
    formik.setFieldValue("productType", data.value);
  };
  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          title={"Type de Produit"}
          containImg={TransectionImg}
          content={"Type de Produit"}
          task={"Une opération de stockage est définie par deux types 'ENTREE' et 'SORTIE' qui représentent respectivement l'incrementation et la décrementation du stock d'une des cultures de votre campagne en cours."}
          handleSubmit={(save) => {
            setSaveAndContinue(save);
            formik.handleSubmit();
          }}
          buttonLabel={"Continuer"}
          backToStartBtn={{
            label: 'Précédent',
            onClick: () => {
              props.onBack();
            }
          }}
        >
          <div>
            <div className="questionPage">
              <div className="transection-option">
                <RadioButton
                  options={options}
                  value={formik.values?.["productType"]}
                  handleChange={(e) => {
                    handleChange(e.target.value)
                  }}
                  formTitle={"Type de Produit"}
                  name="productType"
                  radioButtonClass={"optionforans"}
                  error={Boolean(formik.errors?.["productType"])}
                />
                <Grid
                  className="cahiersheet-optionsheet"
                  style={{ padding: "0 20px" }}
                >
                </Grid>
              </div>
              {Boolean(formik.errors["productType"]) && (
                <p className="errorText">{formik.errors["productType"]}</p>
              )}
            </div>
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};
export default ProductType;



